import { getEntityTabAttributeNonEmptyEntries } from '../EntityTab'

// The Attributes tab is INCON-only and has no dedicated permission: it is
// shown solely when the v2 profile detail response carries renderable external
// CRM (keasy / INCON) `attributes` (it is `null` for non-INCON profiles, and
// may contain only empty groups, which we filter out to keep the tab from
// rendering empty).
export function getUserProfileTabAttributesHasData(userData) {
  return getEntityTabAttributeNonEmptyEntries(userData?.attributes).length > 0
}
